module.exports = __webpack_public_path__ + "static/media/002.2d1634b8.jpg";